export default "__VITE_ASSET__05fffdb5__"